<script>
    import { Row, Container , Col} from 'sveltestrap';
</script>
<footer class="footer">
    <Container fluid={true}>
      <Row>
        <Col md={6}>{new Date().getFullYear()} © LAW&COMPANY.</Col>
        <Col md={6}>
          <div class="text-sm-end d-none d-sm-block">
            판례검색은 <a href="https://bigcase.ai" target="_blank">BIGCASE.AI</a>
          </div>
        </Col>
      </Row>
    </Container>
  </footer>